import { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { FormControl, Tab, Grid, Table } from "@/comn/components";
import { comnEnvs, comnUtils } from "@/comn/utils";
import { Page, Group, Layout, Button, ExcelUpload } from "@/comn/components";
import { eswiEnvs, eswiUtils } from "@/tra/tancis/eswi/comn";
import {
    useForm,
    useFetch,
    useGrid,
    useResource,
    usePopup,
    useStore,
    useToast,
    useAuth,
    useModal,
    useTab,
    usePage,
} from "@/comn/hooks";
import {
    BASE,
    URLS,
    APIS,
    SF_SCHEMA_SRCH_HS_APP,
    SG_SRCH_HS_CODE_LIST,
    SF_SCHEMA_SRCH_HS_APP_ASIN,
    SG_SRCH_HS_CODE_LIST_R,
} from "@/tra/tancis/eswi/hs/vrfn/service/EswiHsVrfnService";

export const ESWI0101003Q = (props: any) => {
    /*
     * Declaration Hook, Meta
     * !== Hook, 메타 정보 정의 ==!
     */
    // const pgeUid = "UI-ESWO-0107-039Q"; // Page Unique identifier !== 화면 고유 식별자 ==! 	HS코드 심사 목록	HS코드 심사 목록을 조회한다.
    //const pgeTitle = "Registration Approval List"; // Page Title !== 페이지 타이틀 ==!
    const { pgeUid, menuId } = usePage({
        auth: ["auth_eswi0007"],
    });
    const { t } = useTranslation(); // Translation Hook !== 언어 변화 Hook ==!
    const navigate = useNavigate(); // Navigate Hook !== 화면 이동 Hook ==!
    const modal = useModal(); // Modal Window Hook !== Modal 창 Hook ==!
    const { pgeStore, setStore } = useStore({ pgeUid: pgeUid }); // Page Store Hook !== 화면 데이터 저장 Hook ==!
    const toast = useToast(); // Toast Message Hook !== Toast 메세지 표시 Hook ==!
    const auth = useAuth(); // Login , User Information Hook !== 로그인, 유저정보 Hook ==!

    /*
     * Code Resource
     * !== 사용할 Code 정의 ==!
     */
    useResource({
        defaultSchema: [
            { area: "orgCd" },
            { area: "comnCd", comnCd: "ESW0009" },
            { area: "comnCd", comnCd: "ESW0030" },
        ],
    });

    /*
     * Declaration Form
     * !== 폼 정의 ==!
     */
    const form = {
        // Registering HS Code Form !== HS 신청 Form==!
        srchHsVrfnForm: useForm({
            defaultSchema: SF_SCHEMA_SRCH_HS_APP_ASIN,
            defaultValues: {
                srchSbmtStrtDtm: comnUtils.getDate({ m: -1 }),
                srchSbmtEndDtm: comnUtils.getDate(),
            },
        }),
    };

    /*
     * Declaration Grid
     * !== 그리드 정의 ==!
     */
    const grid = {
        // Registering HS Code List !== Item Tab HS Code 등록 ==!
        srchHsVrfnList: useGrid({
            defaultSchema: SG_SRCH_HS_CODE_LIST_R,
            page: pgeStore?.page,
            size: pgeStore?.size,
        }),
    };

    const render = {
        srchHsVrfnList: {
            cell: {
                hsAppNo: (props: any) => {
                    const { binding, rowValues, value } = props;
                    console.log(rowValues.hsAppUuid);
                    return (
                        <Layout direction="col" gap={1}>
                            <Link to={`${URLS.eswi0101004s}/${rowValues.hsAppUuid}`}>{`${rowValues.hsAppNo}`}</Link>
                        </Layout>
                    );
                },
            },
        },
    };

    /*
     * Declaration Fetch
     * !== Fetch 정의 ==!
     */
    const fetch = {
        getHsVrfnRsptyList: useFetch({
            api: (page = grid.srchHsVrfnList.page) => {
                return APIS.getHsVrfnRsptyList(form.srchHsVrfnForm.getValues(), page, grid.srchHsVrfnList.size);
            },
            enabled: comnUtils.isEmpty(form.srchHsVrfnForm.errors) && form.srchHsVrfnForm.isSubmitted,
            key: [grid.srchHsVrfnList.page, grid.srchHsVrfnList.size],
            onSuccess: () => {
                setStore(pgeUid, {
                    form: form.srchHsVrfnForm.getValues(),
                    page: grid.srchHsVrfnList.page,
                    size: grid.srchHsVrfnList.size,
                });
            },
            onError: () => {},
            showToast: false,
        }),
    };

    const handler = {
        getHsVrfnRsptyList: (page: number = 0) => {
            form.srchHsVrfnForm.handleSubmit(
                (data) => {
                    grid.srchHsVrfnList.setPage(page);
                    fetch.getHsVrfnRsptyList.fetch(page);
                },
                (data) => {
                    toast.showToast({ type: "warning", content: "msg.00002" });
                },
            )();
        },
        setInit: async () => {
            // 이전 검색 조건 세팅
            eswiUtils.setSrchFormFromStore(form.srchHsVrfnForm, pgeStore);
            handler.getHsVrfnRsptyList();
        },
    };

    useEffect(() => {
        // 초기화
        handler.setInit();
    }, []);

    return (
        <Page>
            {/* <form> */}
            <Group>
                <Group.Body>
                    <Layout>
                        <Layout.Left>
                            <Group.Title title={t("L_APP_INFO")} titleSize={1}></Group.Title>
                        </Layout.Left>
                    </Layout>
                    <Group.Section>
                        <Group.Row>
                            <Group.Control {...form.srchHsVrfnForm.schema.srchOrgCd} />
                            <Group.Control {...form.srchHsVrfnForm.schema.srchHsAppNo} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.srchHsVrfnForm.schema.srchAsnmtBsopTpCd} />
                            <Group.Control {...form.srchHsVrfnForm.schema.srchHsAsnmtOfcrTpCd} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control
                                {...form.srchHsVrfnForm.schema.srchSbmtDtm}
                                edit={true}
                                rangeButton={2}
                                controlSize={4}
                            />
                            <Group.Control {...form.srchHsVrfnForm.schema.srchAsnmtOfcrId} />
                        </Group.Row>
                    </Group.Section>

                    <Layout direction="row">
                        <Layout.Left>
                            <Button 
                                role="reset"
                                onClick={() => {
                                    form.srchHsVrfnForm.reset();
                                }}
                             />
                        </Layout.Left>
                        <Layout.Right>
                            <Button
                                role="search"
                                onClick={() => {
                                    handler.getHsVrfnRsptyList();
                                }}
                            />
                        </Layout.Right>
                    </Layout>
                </Group.Body>
            </Group>

            <Group>
                <Group.Body>
                    <Group.Title title={"L_SRCH_RSTS"} titleSize={2}></Group.Title>
                    <Grid
                        {...grid.srchHsVrfnList.grid}
                        data={fetch.getHsVrfnRsptyList.data?.list}
                        render={render.srchHsVrfnList}
                    />
                </Group.Body>
            </Group>
        </Page>
    );
};
